import { Content } from '@prismicio/client';

import {
  HIV,
  Syphilis,
  Hepatitis,
  Chlamydia,
  Gonorrhoea,
  Trichomonas,
} from '@preventx/oxygen';

type WithIconProps = {
  content: Content.PageHeroHeadlineSliceWithIconPrimary;
};

export const WithIcon = ({ content }: WithIconProps) => {
  const { icon, icon_background_colour } = content;

  if (!icon) {
    return null;
  }

  return (
    <figure
      className="feature-img"
      style={{
        aspectRatio: `var(--c6-ratio-widescreen)`,
        backgroundColor: icon_background_colour ?? 'transparent',
      }}
    >
      {icon === 'HIV' && <HIV fillColour="#4D4D4F" />}
      {icon === 'Syphilis' && <Syphilis fillColour="#D4BEDC" />}
      {icon === 'Hepatitis' && <Hepatitis fillColour="#263271" />}
      {icon === 'Chlamydia' && <Chlamydia fillColour="#263271" />}
      {icon === 'Gonorrhoea' && <Gonorrhoea fillColour="#592D83" />}
      {icon === 'Trichomonas' && <Trichomonas fillColour="#6A3C70" />}
    </figure>
  );
};
